<template>
    <div class="counselling">
        <div class="counselling__container">
            <h2 class="counselling__title">{{ $t('askYourPharmacist.title') }}</h2>
            <p class="counselling__text">{{ $t('askYourPharmacist.text') }}</p>

            <form class="search-input-container" @submit.prevent="searchQueryChanged">
                <input v-model="searchQuery" class="search-input" :placeholder="$t('counselling.searchInputPlaceholder')" />
                <input class="search-submit" type="submit" :value="$t('askYourPharmacist.search')" />
            </form>

            <div v-if="!minimizedBanner" class="counselling__buttons">
                <button class="counselling__add-question" data-cy="add-question" @click="openUpsertModal">
                    {{ $t('askYourPharmacist.addQuestion') }}
                </button>
                <nuxt-link class="counselling__all-questions" data-cy="all-questions" :to="$t('counselling.listLink')">{{
                    $t('askYourPharmacist.showAllQuestions')
                }}</nuxt-link>
            </div>
            <div v-else class="counselling__buttons">
                <nuxt-link class="counselling__add-question text-center" :to="$t('counselling.listLink')">{{
                    $t('askYourPharmacist.addQuestion')
                }}</nuxt-link>
            </div>
        </div>
        <div class="counselling__image">
            <img src="/nuxt-assets/images/png/poradna-new.png" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

defineProps({
    minimizedBanner: {
        type: Boolean,
        required: false,
        default: false,
    },
})

const searchQuery = ref('')
const i18n = useI18n()
const searchQueryChanged = async () => {
    await safeNavigateTo(`${i18n.t('counselling.listLink')}?searchQuery=${searchQuery.value}`)
}

const openUpsertModal = () => {
    useNuxtApp().$bus.$emit('showCounsellingUpsertModal')
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
@import '../../node_modules/bootstrap/scss/mixins';

.search-input-container {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    width: 100%;
    margin-bottom: 10px;

    @include screen-lg {
        width: 380px;
    }
}

.search-submit {
    position: absolute;
    right: 1px;
    top: 0px;
    border-radius: 100px;
    height: 37px;
    display: inline-block;
    background: $color-cta;
    border: 1px transparent;
    cursor: pointer;
    padding: 0 30px;
    color: $color-white;
    transition: all 0.15s ease-in-out;

    &:hover {
        background: $color-cta-dark;
    }
}

.search-input {
    display: inline-block;
    border-radius: 100px;
    border: 1px solid $color-grey-dark;
    background: #fff url('/nuxt-assets/icons/search.svg') no-repeat 15px 11px;
    font-size: 16px;
    font-weight: 400;
    line-height: 36px;
    padding: 0 20px 0 40px;
    color: $color-grey-extra-dark;
    width: 100%;
}

.counselling {
    background: $color-tercial-light-green-3;
    border-radius: 10px;
    position: relative;
    margin: 20px 0 0;
    max-width: 100%;

    @include media-breakpoint-up(lg) {
        display: flex;
        margin: 45px 0 0;
    }

    &__image {
        @include media-breakpoint-up(lg) {
            flex: 0 0 438px;
            align-self: end;

            img {
                position: absolute;
                bottom: 0;
                right: 0;
            }
        }
    }

    &__container {
        flex: 1;
        padding: 24px 20px;

        @include media-breakpoint-up(lg) {
            padding: 44px 14px 44px 35px;
        }
    }

    &__title {
        font-size: 28px;
        font-weight: 450;
        margin: 0;
        padding: 0 0 15px;
    }

    &__text {
        font-size: 16px;
        line-height: 25px;
        margin: 0;
        padding: 0 0 15px;
    }

    &__buttons {
        display: flex;
        flex-direction: column;
        gap: 20px;

        @include media-breakpoint-up(lg) {
            flex-direction: row;
            align-items: center;
            gap: 10px;
        }
    }

    &__add-question {
        width: 200px;
        height: 36px;
        padding: 8px 20px;
        border-radius: 100px;
        background: $color-cta;
        border: 0;
        color: #fff;
        cursor: pointer;
        font-size: 15px;

        &:hover {
            background: darken($color-cta, 3%);
        }
    }

    &__all-questions {
        color: $color-cta;
        font-size: 15px;
        font-weight: 590;
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
